import * as Yup from 'yup';
import { SORTBY_OPTIONS, gamingGenres } from '../../utils/constants';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const GamingGenres = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const gamingGenresOptions = createLocalizedOptions(
    gamingGenres,
    messages,
    SORTBY_OPTIONS.Name
  );

  useEffect(() => {
    const gamingGenresSchema = {
      gamingGenreIds: Yup.array(Yup.number())
        .min(1, intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
        .max(
          5,
          intl.formatMessage({ ...siteMessages.TOO_MANY_VALUES }, { len: 5 })
        )
    };
    updateSchema(gamingGenresSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="gamingGenreIds"
      label={intl.formatMessage({ ...messages.gamingGenres })}
      isMulti={true}
      options={gamingGenresOptions}
      value={values.gamingGenreIds}
      error={errors.gamingGenreIds}
      setFieldValue={setFieldValue}
    />
  );
};

export default GamingGenres;
